import GeoJSON from 'ol/format/GeoJSON';
import KML from 'ol/format/KML';
import { fromLonLat } from 'ol/proj';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Style from 'ol/style/Style';
import $map from '../services/$map';
import { variables } from '../styles/abstract/variables';

class Parcel {
	static getFarmName(farm) {
		try {
			return `${farm.first_name} ${farm.last_name}`;
		} catch (error) {
			return 'Farm 1'
		}
	}

	static isInParcel(lon, lat, id, parcels) {
		try {
			let ps = parcels.filter(parcel => id === parcel.getId())[0].getFeature().getGeometry();
			if (ps.intersectsCoordinate(fromLonLat([lon, lat]))) {
				return true
			} else {
				return false
			}
		} catch (error) {
			console.log(error)
			return false
		}
	}

	constructor(model = {}, feature) {
		try {
			this.id = model.pk;
			this.name = model.name;
			this.area = model.area;
			this.project = model.project
			this.history = model.med_crop_history || [];		
			this.annualYield = model.annual_yield;
			let olFeature = new GeoJSON().readFeature(feature);
			let clone = olFeature.clone();
			clone.setStyle(new Style({
				fill: new Fill({
					color: 'transparent'
				}),
				stroke: new Stroke({
					color: '#ffffff',
					width: 2
				})
			}));

			console.log(clone)
			this.agroforestry = model.is_agroforestry;
			this.farm = { ...model.project.farm, name: Parcel.getFarmName(model.project.farm) };
			this.feature = feature ? new GeoJSON().readFeature(feature) : null;
			this.kml = clone ? new KML().writeFeatures([clone], {dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857'}) : null;
			this.kml = this.kml.replace('<PolyStyle>', '<PolyStyle><fill>1</fill>');
			console.log(this.kml);
			this.applicabilityStatus = feature.properties.applicability_status
			this.status = model.entries.map(obj => ({...obj.status[0], id: obj.id}));
			this.biomass = model.entries.map(obj => ({...obj.biomass_status[0], id: obj.id}));
			this.soc = model.entries.map(obj => ({...obj.soc_status[0], id: obj.id}));
			this.years = model.entries.map(obj => obj.status[0].year);
		} catch (error) {
			console.log(error)
		}


	}

	getId() {
		return this.id;
	}

	getName() {
		return this.name || 'Uknown';
	}

	getArea() {
		return this.area.toFixed(2);
	}

	isAgroforestry() {
		return this.agroforestry;
	}

	getFeature() {
		return this.feature;
	}

	getProperties() {
		return this.feature ? this.feature.getProperties() : {};
	}

	getFarm() {
		return { ...this.farm }
	}

	getCentroid() {
		return this.feature.getGeometry().getInteriorPoint().getCoordinates();
	}

	zoomTo(view) {
		view.fit(this.feature.getGeometry(), {padding: [125, 125, 125, 125]})
	}

}

export default Parcel;